export default __webpack_public_path__ + "dab3624466fabff6b1069423f2b74c59.svg";